import React from "react";

import { stringToBoolean } from "@utils/attributes";
import { BreakpointProvider } from "@utils/breakpoints/breakpoints.provider";

import _TextComponent from "./text.component";

type Props = {
    text: string;
    color: string;
    readMoreMobileEnabled: string;
    readMoreDesktopEnabled: string;
};

const TextContainer = ({
    text,
    color,
    readMoreMobileEnabled,
    readMoreDesktopEnabled,
}: Props) => {
    return (
        <BreakpointProvider>
            <_TextComponent
                text={text}
                color={color}
                readMoreMobile={stringToBoolean(readMoreMobileEnabled)}
                readMoreDesktop={stringToBoolean(readMoreDesktopEnabled)}
            />
        </BreakpointProvider>
    );
};

export { TextContainer };
